import styled from "@emotion/styled";

export const PersonCommunicationSettingsContent = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	backgroundColor: theme.project.colors.backgroundColors.main,
	color: theme.project.colors.fontColors.secondary,
	gap: "8px",
	"& > div:first-of-type": {
		...theme.project.typography.subtitle.subtitle1
	}
}));

export const PricingFormatLabel = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	fontSize: "16px",
	fontWeight: 500
}));

export const PersonButtonsContainer = styled.div({
	display: "flex",
	justifyContent: "end",
	gap: 24,
	".MuiButton-root": {
		minWidth: 120
	}
});
